<template>
  <div>
    <provider-detail-o-p-pending-component />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>